import ApplicationController from '../application_controller'

class ModalsController extends ApplicationController {
  connect () {
    const element = this.element

    document.addEventListener('turbo:before-stream-render', function () {
      element.scrollTop = 0
    })
  }
}

export default ModalsController
